export const REDIRECT_URL = `${process.env.REACT_APP_EP_ENV_URL}`;

export const redirectToRails = (otherQueries = "") => {
    const jwt = localStorage.getItem("jwt")
    if (!jwt) return
    window.location.href = `${REDIRECT_URL}?jwt=${jwt}${otherQueries}`
  }